import WidgetModule from "@eisinc/Overrides/Widgets/Budget/AssignBudgets";

export * from "@eisinc/Overrides/Widgets/Budget/AssignBudgets";

export default WidgetModule;
